// Mock data for Çanakkale Konut Rehberi (ÇKR)
// All content is placeholder/sample data for the frontend-only build.

export const brand = {
  name: 'Çanakkale Konut Rehberi',
  short: 'ÇKR',
  person: 'M. Kutay Öztürk',
  location: 'Çanakkale',
  tagline: 'İlan ezberiyle değil; piyasa gerçekleriyle konut kararı.',
};

export const navLinks = [
  { label: 'Piyasa Endeksi', href: '/#piyasa' },
  { label: 'Bana talebini ilet', href: '/ihtiyac-analizi/' },
  { label: 'Almaya / satmaya gerçekten hazır mısın?', href: '/motivasyon/' },
  { label: 'Ben Kimim', href: '/ben-kimim/' },
  { label: 'Blog', href: '/blog/' },
  { label: 'Danışmanlık', href: '/danismanlik/' },
  { label: 'İletişim', href: '/iletisim/' },
];

// Piyasa endeksi — 2025 Ocak'tan bugüne aylık işlenmiş veri seti.
export const marketMonths = [
  {
    id: 'ocak-2025',
    month: 'Ocak',
    year: '2025',
    status: 'Dengeli',
    statusNote: 'Piyasa temkinli ama dengeli ilerliyor',
    totalSales: '842',
    salesIpoteksiz: '694',
    salesIpotekli: '148',
    rentIncrease: '%55,80',
  },
  {
    id: 'subat-2025',
    month: 'Şubat',
    year: '2025',
    status: 'Dengeli',
    statusNote: 'Talep seçici, fiyatlar pazarlığa açık',
    totalSales: '876',
    salesIpoteksiz: '716',
    salesIpotekli: '160',
    rentIncrease: '%54,10',
  },
  {
    id: 'mart-2025',
    month: 'Mart',
    year: '2025',
    status: 'Canlanıyor',
    statusNote: 'Bahar talebiyle hareket artıyor',
    totalSales: '928',
    salesIpoteksiz: '751',
    salesIpotekli: '177',
    rentIncrease: '%52,60',
  },
  {
    id: 'nisan-2025',
    month: 'Nisan',
    year: '2025',
    status: 'Canlanıyor',
    statusNote: 'Alıcı ilgisi bölgesel olarak güçleniyor',
    totalSales: '981',
    salesIpoteksiz: '788',
    salesIpotekli: '193',
    rentIncrease: '%50,90',
  },
  {
    id: 'mayis-2025',
    month: 'Mayıs',
    year: '2025',
    status: 'Dengeli',
    statusNote: 'Satıcı beklentisi ile alıcı teklifi yakınlaşıyor',
    totalSales: '1014',
    salesIpoteksiz: '816',
    salesIpotekli: '198',
    rentIncrease: '%49,20',
  },
  {
    id: 'haziran-2025',
    month: 'Haziran',
    year: '2025',
    status: 'Dengeli',
    statusNote: 'Yaz etkisiyle kiralık talebi öne çıkıyor',
    totalSales: '1048',
    salesIpoteksiz: '839',
    salesIpotekli: '209',
    rentIncrease: '%47,80',
  },
  {
    id: 'temmuz-2025',
    month: 'Temmuz',
    year: '2025',
    status: 'Seçici Talep',
    statusNote: 'Alıcılar fiyat/konum dengesine daha hassas',
    totalSales: '1067',
    salesIpoteksiz: '852',
    salesIpotekli: '215',
    rentIncrease: '%46,40',
  },
  {
    id: 'agustos-2025',
    month: 'Ağustos',
    year: '2025',
    status: 'Seçici Talep',
    statusNote: 'Doğru fiyatlanan mülkler daha hızlı ayrışıyor',
    totalSales: '1092',
    salesIpoteksiz: '870',
    salesIpotekli: '222',
    rentIncrease: '%45,10',
  },
  {
    id: 'eylul-2025',
    month: 'Eylül',
    year: '2025',
    status: 'Dengeli',
    statusNote: 'Okul dönemiyle merkez talebi yeniden belirgin',
    totalSales: '1125',
    salesIpoteksiz: '895',
    salesIpotekli: '230',
    rentIncrease: '%43,70',
  },
  {
    id: 'ekim-2025',
    month: 'Ekim',
    year: '2025',
    status: 'Alıcıya Dönüyor',
    statusNote: 'Pazarlık payı yükseliyor',
    totalSales: '1108',
    salesIpoteksiz: '884',
    salesIpotekli: '224',
    rentIncrease: '%42,30',
  },
  {
    id: 'kasim-2025',
    month: 'Kasım',
    year: '2025',
    status: 'Alıcıya Dönüyor',
    statusNote: 'Bekleyen ilanlarda fiyat revizyonu ihtiyacı artıyor',
    totalSales: '1084',
    salesIpoteksiz: '864',
    salesIpotekli: '220',
    rentIncrease: '%40,90',
  },
  {
    id: 'aralik-2025',
    month: 'Aralık',
    year: '2025',
    status: 'Alıcı Lehine',
    statusNote: 'Yıl sonu kararlarında gerçekçi fiyat avantaj sağlıyor',
    totalSales: '1059',
    salesIpoteksiz: '846',
    salesIpotekli: '213',
    rentIncrease: '%39,60',
  },
  {
    id: 'ocak-2026',
    month: 'Ocak',
    year: '2026',
    status: 'Alıcı Lehine',
    statusNote: 'Talep var ama fiyat seçiciliği yüksek',
    totalSales: '1018',
    salesIpoteksiz: '814',
    salesIpotekli: '204',
    rentIncrease: '%38,20',
  },
  {
    id: 'subat-2026',
    month: 'Şubat',
    year: '2026',
    status: 'Alıcı Lehine',
    statusNote: 'Nakit alıcı pazarlıkta daha güçlü',
    totalSales: '1036',
    salesIpoteksiz: '828',
    salesIpotekli: '208',
    rentIncrease: '%36,90',
  },
  {
    id: 'mart-2026',
    month: 'Mart',
    year: '2026',
    status: 'Dengeleniyor',
    statusNote: 'Talep yeniden ölçülü şekilde canlanıyor',
    totalSales: '1079',
    salesIpoteksiz: '858',
    salesIpotekli: '221',
    rentIncrease: '%35,50',
  },
  {
    id: 'nisan-2026',
    month: 'Nisan',
    year: '2026',
    status: 'Dengeleniyor',
    statusNote: 'Doğru fiyatlı portföylerde görüşme artıyor',
    totalSales: '1116',
    salesIpoteksiz: '886',
    salesIpotekli: '230',
    rentIncrease: '%34,20',
  },
  {
    id: 'mayis-2026',
    month: 'Mayıs',
    year: '2026',
    status: 'Dengeli',
    statusNote: 'Alıcı ve satıcı beklentisi daha okunabilir',
    totalSales: '1138',
    salesIpoteksiz: '906',
    salesIpotekli: '232',
    rentIncrease: '%33,10',
  },
  {
    id: 'haziran-2026',
    month: 'Haziran',
    year: '2026',
    status: 'Dengeli',
    statusNote: 'Piyasa alıcı ve satıcı arasında dengeli',
    totalSales: '1120',
    salesIpoteksiz: '905',
    salesIpotekli: '215',
    rentIncrease: '%32,40',
  },
  {
    id: 'temmuz-2026',
    month: 'Temmuz',
    year: '2026',
    status: 'Alıcıya Dönüyor',
    statusNote: 'Talep yavaşlıyor, piyasa alıcı lehine dönüyor',
    totalSales: '1185',
    salesIpoteksiz: '960',
    salesIpotekli: '225',
    rentIncrease: '%31,85',
  },
  {
    id: 'agustos-2026',
    month: 'Ağustos',
    year: '2026',
    status: 'Alıcı Lehine',
    statusNote: 'Piyasa şu an alıcı lehine',
    totalSales: '1248',
    salesIpoteksiz: '1018',
    salesIpotekli: '230',
    rentIncrease: '%31,79',
  },
  {
    id: 'eylul-2026',
    month: 'Eylül',
    year: '2026',
    status: 'Alıcı Lehine',
    statusNote: 'Gerçekçi fiyatlanan mülkler daha görünür',
    totalSales: '1216',
    salesIpoteksiz: '994',
    salesIpotekli: '222',
    rentIncrease: '%30,90',
  },
  {
    id: 'ekim-2026',
    month: 'Ekim',
    year: '2026',
    status: 'Seçici Piyasa',
    statusNote: 'Son veriler alıcının daha seçici davrandığını gösteriyor',
    totalSales: '1194',
    salesIpoteksiz: '981',
    salesIpotekli: '213',
    rentIncrease: '%30,20',
  },
];

export const testimonials = [
  {
    name: 'Mehmet K.',
    text: 'Allah razı olsun ihtiyacımız vardı, istediğimiz fiyattan satmamıza yardımcı oldunz. Allah yolunuzu açık etsin!',
  },
  {
    name: 'Ahmet Y.',
    text: 'Başta yaptıkları değerlemeye göre düşündüğümüz fiyatın çok altında bir değer çıkardılar. Sonra satılmayınca tekrar görüştük ve kısa sürede satabildik. Teşekkürler.',
  },
  {
    name: 'Hüseyin D.',
    text: 'Hangi fiyata ne kadar süre bekleyeceğimi bile söylediler. Orta yolu bulduk 2 ayda sattık teşekkür ederim.',
  },
  {
    name: 'Mustafa A.',
    text: 'bakış açımı değiştirdi Kutay bey allah razı olsun.',
  },
  {
    name: 'İbrahim T.',
    text: 'Ev arama sürecimizde bize hem danışmanlık hem de manevi destek verdi Kutay bey, sizi seviyoruz.',
  },
  {
    name: 'Hasan Ç.',
    text: 'Birkaç kere beraber çalıştık ben oldukça memnununm. Kolay gelsin.',
  },
  {
    name: 'Osman Ö.',
    text: 'Güler yüzlü ve çok anlayışlı birisi kendisi. süreçteki tüm çekincelerimi dinledi ve bana herşeyi detaylı anlattı. Teşekkür ederiz.',
  },
  {
    name: 'Ali R.',
    text: 'İlk görüşmede çekindim dövmeleri görünce ama kimseye önyargıyla yaklaşmamak lazımmış. Ben işine bu kadar özenen bir insan görmedim. Allah razı olsun. Teşşekürler.',
  },
  {
    name: 'İsmail G.',
    text: 'Çok güzel bir insan kendisi Allah herkesin karşısına böyle düzgün insanlar çıkarsın.',
  },
  {
    name: 'Süleyman B.',
    text: 'Kutay beyle tanışana kadar farkettim ki herşeyi yanlış yapıyormuşum. sağolsun bana herşeyi baştan sona olması gerektiği gibi anlattı.',
  },
  {
    name: 'Fatma Ş.',
    text: 'Marjinal tarzıyla dikkat çeken bir insan kendisi :) işinde gerçekten iyi. Teşekkürler.',
  },
  {
    name: 'Ayşe E.',
    text: 'Babasını da tanırım. Dürüst ahlaklı insan bulmak zor bu devirde. Yolun açık olsun evlat.',
  },
  {
    name: 'Emine C.',
    text: 'Evimi kiraya veremiyordum ne zamandır sağolsun çok yardımcı oldu Kutay bey',
  },
  {
    name: 'Hatice M.',
    text: 'Sosyal medyadan takip ediyordum emlakçılara olan bakışımı değiştirdi kendisi. Tebrikler.',
  },
  {
    name: 'Zeynep S.',
    text: 'İşini düzgün yapmak için çaba harcayan geçiştirmeyen eksik bilgi vermeyen olanı söyleyen temiz bir insan kendisi. Teşekkürler.',
  },
  {
    name: 'Nermin A.',
    text: 'Beraber çalışamadık ama bana sanki kendi müşterisiymişim gibi ilgi gösterdi, çok teşekkür ediyorum.',
  },
  {
    name: 'Şükran K.',
    text: 'Düzgün ve kaliteli bir insan kendisi. Yardımlarınız için teşekkür ederim.',
  },
];


export const consultancySteps = [
  {
    "no": "01",
    "title": "İhtiyaç Analizi",
    "headline": "Ne istediğiniz kadar, ne kadar hazır olduğunuz da önemli.",
    "desc": "Hedeflerinizi, bütçenizi ve motivasyonunuzu analiz ederek sürecinizi belirsizliklerden arındırıyoruz.",
    "subtitle": "Bir şeyi çok istemek, onu gerçekleştirmeye hazır olduğunuz anlamına gelmez.",
    "paragraphs": [
      "Önce hedeflerinizi, beklentilerinizi, bütçenizi ve sizi harekete geçiren nedenleri anlamaya çalışıyoruz.",
      "Gerçek motivasyon; gerekli koşulları oluşturmak, belirsizlikleri gidermek ve belirlediğiniz zamanda harekete geçebilmektir.",
      "Bu nedenle web sitemizde bir Motivasyon Analizi hazırladık. Bu analizle kararınızı etkileyen koşulları, henüz cevaplanmamış soruları ve sürecinizi geciktirebilecek noktaları birlikte değerlendiriyoruz.",
      "Amacımız sizi acele ettirmek değil, neye hazır olduğunuzu ve ilerlemek için neye ihtiyacınız olduğunu görmenizi sağlamak."
    ]
  },
  {
    "no": "02",
    "title": "Piyasa Okuması",
    "headline": "İlan vitrinine değil, piyasanın gerçek hikâyesine bakıyoruz.",
    "desc": "Gerçekleşmiş işlemleri, saha verilerini ve danışman ağımızdan edindiğimiz bilgileri değerlendiriyoruz.",
    "subtitle": "İlan vitrinine değil, piyasanın gerçek hikâyesine bakıyoruz.",
    "paragraphs": [
      "Bir mülkün ilana hangi fiyatla çıktığını herkes görebilir. Peki ne kadar süredir satılamadığını, hangi teklifleri aldığını, neden fiyat değiştirdiğini veya benzer mülklerin gerçekte kaça satıldığını?",
      "Kendi veri tabanımızı, saha çalışmalarımızı ve profesyonel danışman ağımızdan edindiğimiz bilgileri bir araya getiriyoruz.",
      "Ulaşabildiğimiz gerçekleşmiş satış verilerini, alıcı davranışlarını, rakip mülkleri ve fiyat değişimlerinin arkasındaki nedenleri inceliyoruz.",
      "Çünkü ilan fiyatı, bir mülkün satılabileceği fiyat anlamına gelmez.",
      "Amacımız size yalnızca piyasada neyin kaç liraya ilan edildiğini değil, hangi koşullarda, hangi fiyat aralıklarında gerçek bir işlem gerçekleşebileceğini göstermek."
    ]
  },
  {
    "no": "03",
    "title": "Karar Zemini",
    "headline": "İyi bir karar, fırsatları ve riskleri birlikte görebilmektir.",
    "desc": "Seçeneklerinizi karşılaştırıyor, kararınızın olası sonuçlarını somut verilerle değerlendiriyoruz.",
    "subtitle": "İyi bir karar, yalnızca fırsatları değil riskleri de görebilmektir.",
    "paragraphs": [
      "İhtiyaçlarınızı belirledik, piyasayı değerlendirdik. Şimdi tüm bu bilgileri sizin koşullarınızla bir araya getiriyoruz.",
      "Mülkün fiyatını, konumunu, fiziksel özelliklerini, ulaşılabilir hukuki bilgilerini, potansiyelini ve olası risklerini değerlendiriyoruz.",
      "Alternatiflerin güçlü ve zayıf yönlerini karşılaştırıyoruz.",
      "Bir satıcı için gerçekçi fiyat ve satış süresi beklentisi, bir alıcı için doğru mülk seçimi ve pazarlık sınırları oluşturmaya yardımcı oluyoruz.",
      "Size ne yapmanız gerektiğini söylemek yerine, vereceğiniz kararın olası sonuçlarını görmenizi sağlıyoruz.",
      "Çünkü bizim için doğru karar, herkes için aynı olan değil; sizin ihtiyaçlarınıza ve koşullarınıza en uygun olan karardır."
    ]
  },
  {
    "no": "04",
    "title": "Yönlendirme",
    "headline": "Danışmanlık, karar verdiğinizde bitmez.",
    "desc": "Pazarlıktan belge kontrollerine, satış ve kiralama işlemlerinden sonuçlandırmaya kadar yanınızdayız.",
    "subtitle": "Danışmanlık, ne yapmanız gerektiğini anlatmakla bitmez.",
    "paragraphs": [
      "Kararınızı uygulamaya geçirdiğinizde de sürecin içindeyiz.",
      "Satıcılar için doğru pazarlama stratejisini oluşturuyor, mülkün uygun alıcılara ulaşması için çalışıyor, gelen talepleri ve teklifleri değerlendiriyoruz.",
      "Alıcılar için uygun seçenekleri araştırıyor, diğer danışmanlarla iletişim kuruyor, mülk ve belge kontrollerini koordine ediyor, pazarlık sürecinde çıkarlarını gözetiyoruz.",
      "Görüşmelerden sözleşmelere, tapu veya kiralama işlemlerine kadar ilgili taraflarla koordinasyonu sürdürüyoruz.",
      "Amacımız yalnızca bir satış ya da kiralama işlemini tamamlamak değil; doğru kararın doğru koşullarda hayata geçirilmesini sağlamak."
    ]
  }
];
export const aboutText = {
  portrait: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e',
  paragraphs: [
    'Merhaba, ben M. Kutay Öztürk. Çanakkale\'de alıcı, satıcı, kiracı ve kiraya verenlere; ilan ezberiyle değil, piyasa gerçekleriyle karar rehberliği sunuyorum.',
    'Benim işim size ev beğendirmek değil; doğru soruları sorarak, bütçeniz ve ihtiyacınızla örtüşen sağlam bir karar zemini oluşturmak. İlan fiyatı ile satılabilir fiyat arasındaki farkı net göstermek, bu işin özüdür.',
    'ÇKR; bölge, bütçe, satılabilir fiyat ve kira potansiyelini birlikte okur. Böylece acele değil, bilinçli kararlar verirsiniz.',
  ],
  highlights: [
    { value: '12+', label: 'Yıl saha tecrübesi' },
    { value: '%100', label: 'Gerçek piyasa verisi' },
    { value: 'Çanakkale', label: 'Odaklı bölge uzmanlığı' },
  ],
};

// Melis asistan — kural tabanlı akış
export const melis = {
  name: 'Melis',
  role: 'ÇKR Dijital Asistanı',
  greeting: 'Merhaba, ben Melis. Size doğru yönlendirmeyi yapabilmem için durumunuzu seçer misiniz?',
  disclaimer: 'Melis, ÇKR\'nin dijital yardımcı asistanıdır.',
  options: [
    { key: 'alici', label: 'Ev almak istiyorum', target: 'alici', reply: 'Harika! Doğru evi doğru fiyata bulmak için kısa bir Alıcı İhtiyaç Analizi yapalım. Formu sizin için açıyorum.' },
    { key: 'satici', label: 'Evimi satmak istiyorum', target: 'satici', reply: 'Satılabilir fiyatı net konuşalım. Satıcı İhtiyaç Analizi formunu açıyorum, birkaç soruyla başlıyoruz.' },
    { key: 'kiraya-veren', label: 'Evimi kiraya vermek istiyorum', target: 'kiraya-veren', reply: 'Kira potansiyelinizi gerçek piyasaya göre belirleyelim. Kiraya Veren analizini açıyorum.' },
    { key: 'kiralayan', label: 'Kiralık ev arıyorum', target: 'kiralayan', reply: 'Bütçe ve ihtiyacınıza göre bölge önerelim. Kiralayan İhtiyaç Analizini açıyorum.' },
  ],
};
